module.exports = __webpack_public_path__ + "img/Atletico-Madrid.4d944687.png";